import { Avatar, AvatarFallback, AvatarImage } from "@kubdee/ui/shadcn/avatar";
import { cn } from "@kubdee/ui/lib/utils";

interface UserAvatarProps {
  name?: string | null;
  email?: string | null;
  avatarUrl?: string | null;
  className?: string;
  fallbackClassName?: string;
}

function getInitial(name?: string | null, email?: string | null) {
  const source = name?.trim() || email?.trim() || "U";
  return source.charAt(0).toUpperCase();
}

export function UserAvatar({
  name,
  email,
  avatarUrl,
  className,
  fallbackClassName,
}: UserAvatarProps) {
  const label = name?.trim() || email?.trim() || "ผู้ใช้";
  const src = avatarUrl?.trim() || undefined;

  return (
    <Avatar className={cn("bg-[#48bb78]", className)} title={label}>
      {src ? <AvatarImage src={src} alt={label} /> : null}
      <AvatarFallback
        className={cn(
          "bg-[#48bb78] font-semibold text-white",
          fallbackClassName
        )}
      >
        {getInitial(name, email)}
      </AvatarFallback>
    </Avatar>
  );
}
